
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index75rWXi_Z3GpFKQfPi0flDxI6SVljxOZgciNZY0hk5g4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/index.vue?macro=true";
import { default as loginr5vSxhI_45a6ZvgsPQjkpzB_Wa4DvHjJUtXsSXCAU_MK8Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/login.vue?macro=true";
import { default as mgenevbS574GPuTuG1iZUS099d3gvzfkJ4jEctscUHK_8PoMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/quiz/mgen.vue?macro=true";
import { default as indexvMV6Jvp0GLnlfJ5DvriYQt5OefP106PKhIfVAsNKHUgMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/index.vue?macro=true";
import { default as notestG4iCUysvBM_m5sVjznX0oawwGT0XIjuluheYgdkSi0Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/notes.vue?macro=true";
import { default as indexzYWBKLYFXLfgOI3IG4yrHPJFEu0acMkvFaP27w00sn4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentSC3dmdqruggR8wrCVOpxy3Twqp8QgZlMpGur2pBkfMgMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45sitezwJILGPh0AM1HD_2lMK5Z4b3ab2NL6IuwfiT7pIiIu4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/plan-du-site.vue?macro=true";
import { default as editEhk7Uy0VVr6h3NQe3qHDcb6O36Mbvd1_dX7zk5zE27cMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/edit.vue?macro=true";
import { default as placesM0LxWIVOVWp11z9RVtAZRm0SIBpmelgcUTkM48zTx70Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/stats/places.vue?macro=true";
import { default as accessibiliteyS_45UjVtn1FvbKgrisQR24jgWZ09MYLCMso3CBUSa76IMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/accessibilite.vue?macro=true";
import { default as _91id_939rplnhWz3jZEMp5vALreaMYcO3oq7c9bD3mMNEZ_45csIMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/messages/[id].vue?macro=true";
import { default as notificationskcTUh_45sSNmI8teTuUwmX1ymFMA_1kIzCydMaHCeQ7q8Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/notifications.vue?macro=true";
import { default as indexpfW9LKe566NGEV1GAFWQBgYM8pA_451X_45H6W9AmRk0h14Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/index.vue?macro=true";
import { default as indexxcOy79lfPLXK3tDyi0Q8iKfjp30bT4q5_45STornWh4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/index.vue?macro=true";
import { default as _91slug_93OpQUGU4fnHs_45jamXPyO3OMtDwagEkZcQw9vs_458wRik4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/villes/[slug].vue?macro=true";
import { default as indexH8OtL1YimpGbYqXVx_zjvhv57tEo635_45fLNZsr6DwTwMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/messages/index.vue?macro=true";
import { default as generiquewJXD5RUfmhdrawH1mjexanVLOenhPjUTNq1JvTeF48IMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93p_45bhIQPlxcRNvUtBqE4RFRkl3B3oEVe140oVnqdpQZQMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/reseaux/[slug].vue?macro=true";
import { default as missionsWW2TmFv2x6xH3Sfvc7l4kLJfDiA_45HLseVMoltP22rjYMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/stats/missions.vue?macro=true";
import { default as indexZEhN_HPvz7YDK7_TMC_gdfR3EfOLUSRMghfoi02y1ZIMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/dashboard/index.vue?macro=true";
import { default as favorisaAjZ_8b2sg9rMUYIm9M_45i5GFpxRZ8t9PVQMqQjQ_45AMsMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93Ry_aLJnN6kuwYT_45RFE7OscK2s4W0mvvgLHdAp7aXH_45MMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/activites/[slug].vue?macro=true";
import { default as logsS4Y75yRVKpc9L5M6Mu6oWoxNayxqzGApgN8EAYhO8lcMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/other/logs.vue?macro=true";
import { default as ressourcesEkih2yN8TIsaKsXWoQQVCX3YKXSp2TWtU8J92AOpAycMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legalesGgyKSKq69hAQta2D6oes3lXC1HfjMTABccq0_A1cvaUMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/mentions-legales.vue?macro=true";
import { default as missions0rAnTYYgcAca20s5hb5z1hxDvDaxqKKka_kYmuw4SmoMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/missions.vue?macro=true";
import { default as settingsPMElegGXlxCDh_453OdQYctXrho4FTU3aM3dH3i4zF1EEMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/settings.vue?macro=true";
import { default as tournee_45eteL6DeDn9Y5aEOx43EiOstzhEKbKdLHZfYd43HwYy1NB8Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/quiz/tournee-ete.vue?macro=true";
import { default as temoignageseBzvtKXGBkY6unx_MsnddNCtleUIvBMmpoSF0hSpoBEMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/temoignages.vue?macro=true";
import { default as indexYLh75qZcHeKS_2VBD6K_tPVXu1fv_45YIf62xHfQyKuAoMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/index.vue?macro=true";
import { default as adminuaE8W89B7IT0F298udgcaYpz3K_451XF6a7bh1sB5C65gMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/maintenance/admin.vue?macro=true";
import { default as indexs7mTzlWSxHtC7Qdtqc_LNYhQ7v9gal10zoP9rBrGVDUMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/maintenance/index.vue?macro=true";
import { default as indexNdPc6V_Jua07K9tBybJAzXMiir5YrpiVZTzSuGG7aDgMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/territoires/index.vue?macro=true";
import { default as _91hash_93lCM_1BQo_45G_452s17YqSxCh9pHm37yGzB9XfeYAw4LPUoMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursmbvMr30yo9M6C2wV4U5lIej2mc15i5Z7LMUMGSzFzrUMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93yo7kjdHa4eGDI_htfc8SqxXPRe3eDbxzPTxZsShpxqkMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93O_YOmBaya9mNnRYNeRSmu8_45WwMfzAp_45g3dkLA9uch5EMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/departements/[slug].vue?macro=true";
import { default as indexVkGUWxbLZRb0sacy5Bo39SoLQVwP7n9_45cP4hqvYu7jEMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/organisations/index.vue?macro=true";
import { default as preferencesExPDQYAmN6odPY02MqX88QTOWZnlP4szgcja_457jRR_45gMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/preferences.vue?macro=true";
import { default as organisationsIXC_DeVwkKRGa9sgmQymHDM_45AONPSYHcQPV8oOGQG_45AMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/stats/organisations.vue?macro=true";
import { default as _91token_93r2JC9xYxv7U1uUKrCYzPR_45C9Yokmk1YLdfYALYx89V4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/temoignages/[token].vue?macro=true";
import { default as postsslr7mXqyDinXi_45Z70mmAMAyLXJdeo2iaZuJ5nsM5JTQMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/posts.vue?macro=true";
import { default as index6Y5hJhUT04d5JfLuyRk9G0xxack_LMDwGxc6XNIChBwMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/index.vue?macro=true";
import { default as addfZ8WtJV4wi_TXMsnngqeLVyoC4fw8vbEt1w95NMWyh8Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_93KTHbn_45mAN7q9Gm3_S_FhCu3uEGaTxQmIafumvFqeCTIMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/organisations/[slug].vue?macro=true";
import { default as indexy_1BotC7ARA4V883fLNSShuVpNuIqUmux84G93VrSZYMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/password-reset/index.vue?macro=true";
import { default as participationsFLgOwJpWjUN9y0bFU3fwiMENMU53pLeoArTRAB2aEJwMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/stats/participations.vue?macro=true";
import { default as emailsMt_45js_45QuVzx4n52qaNy_dKBUL76AtT2lEQu6R7tPvn0Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/settings/emails.vue?macro=true";
import { default as indexnkEkxWlZZlf6SoGzapne5KyEbLUkomt30OXUC442M_45EMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/alertes/index.vue?macro=true";
import { default as notifications1X6TvGZvwMqYV4g5bHZ7bHlc6VtoTdx0Bj6NDDflFAgMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/notifications.vue?macro=true";
import { default as indexrELugclqibTkh1EVnktr_bFen7NrF_45aCzB13Wq5wnOAMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civiqueBgEEFH9j7XPhyZzFZhNGBpdvNckSI_H10dGA5OGF4HgMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93cJYFppiBZ_458sKRautbHL49MTplgnZpsgmH_Yuc4hsAMMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/domaines-action/[slug].vue?macro=true";
import { default as indexXVCJ5EJ1CRAAmokoqPQCCyrQqd7BL7DGHERZzxxnWQQMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93v8fkHm_45uBR7z7PJWL_455RXT8QJnLf9Vo6GmKRZXeQRmIMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensemblebzxcsbHXfsDTB6cp95gccDmmhzE8DLg0ErF0IzEwIWUMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationsFbJ18YyP3CbknbR1C2mqrKSoTxv4Mwptv51ZfBfv75YMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/other/invitations.vue?macro=true";
import { default as messagesFdwBGD6DImnLswosVtYN6GoAQTTyCEqx3wqgQDNAASQMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/settings/messages.vue?macro=true";
import { default as placesiTT6UOTCOIFE3mYhbqfX1ZKpp_45_45YVrf0dHIiDgSy7XYMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/places.vue?macro=true";
import { default as addYLpYf8QPuwBStl8fdE1pjs8rEYdEyZpXgzJTqcWEaD0Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexXi46sxUe56VJA_4512LS2Rn2dnH_45uqDkNDr3xceig_L5cMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/utilisateurs/index.vue?macro=true";
import { default as index1g_45rm26uegf8BXEHXwgpj2gZhr85owTANwG_45VmkMXqUMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/missions-benevolat/index.vue?macro=true";
import { default as datesFxfdho_ZgLf7leWtUs_45koqSm4nf2RZVpqGJF3X30WpYMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexBxYREYtyZP_45166Pwnjw8vVjhOupOZpVYa3B2MIwRmxEMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieux14vhSvtuK_45Td8eU21Tc8JhaKahw56K4LxnOXG7AntZYMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titleEbET6OoaNR1ZTvGAj3uaEVJguhJfYnjQyxKoRuHuKjQMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/title.vue?macro=true";
import { default as index0XaAfTawOWBds0PALsO9uATbpz91aE0ht6FkNkH8pugMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/organisations/index.vue?macro=true";
import { default as missionsmtE0B3fAbHeNuHuZJkzt3jOWVFpKUwHPEaMfRzjR0e0Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/missions.vue?macro=true";
import { default as addmgtyVu0nnVSHF7WYa0ARoIw9EoCOxY_vZuU84Bo4iM4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuelyJGhqbra4J4V91qFZ9iAfPqglx47t7NTos6K4bOYzTkMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexhIYSsBo0SbK7nSu18OhEo2oHq7DYQBnDynha_45DV2q_IMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/participations/index.vue?macro=true";
import { default as indexWtwfvRSCDyNRKjXPG5ArRio1EZLA3R54N1jlLzaRQmYMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexVm5WDiVaKv8euyAQlQfoMGTWB6MR0gjHNzbXJjBvI0sMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/benevole/index.vue?macro=true";
import { default as addV2nuf5F0hhnqM3_aKxEzmfAUZJ_45WwmOR9RQGwgksOo0Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as addW73o7xB_45TVoE4ceNPUSXkmK29XU6ZS6tjRRokgM5xoMMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addraw1lrECAg0JAE7OA4E5k3CZtOuPzpZpVKj4rLeY_45SoMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexm7FdPRGYKUeYKFj50gDw3eIz1rjJuxGYAz5QU2Sv5jMMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversions8OIHj8gx1U_45ya5F6X0f80aOsvYIwsQUXyp6WBplYtDgMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/conversions.vue?macro=true";
import { default as editwt6M_TWf3N24WrZ0m_8xndfYgcnfQp8aZLK14IZYFCoMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialiteAGHhgDyypQqCUKeCu8D4k464Xce5iYA_45EI3AXPriMgoMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/politique-de-confidentialite.vue?macro=true";
import { default as index3fm4C8tAPQkuukcv9_NHkGvgLUd4wkX0n0A1wBKUwwwMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as addozPt1okzkJqC_45UhRHjaxAk5ElgMjanvzEyZu0GRH_45_sMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevolesnYYQb61nZIzFhccKR_mGgDMbj29SXaBnvrViAj9rVi8Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editRE4MRS4PhSxu1ua0U0M4TnWuG_U00J62mMLxXJ6QJAMMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateursseaOAZdxRurmf2UpglPgP51KoVxsPyZO4VIwv8TVMMgMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexDkkGKYdA3kgDDslw292GK_45VPsAYu_45lPWkCdmTjbONf8Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as index8Dc5McLX3e6HURPn0cr_45p6z0SnmQp_45iYaZAOcnIw9hIMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexsuMoBGIBR_CtvAKLRyTg5Bdns0MeZWZegWSoMmLBC8YMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/index.vue?macro=true";
import { default as indexbvLdWGHbsOtegk4HP1hvKdC2Yvyy8O3x_45GIVMJE8Xc4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendrePo3iry3iiEy6MIrwWnAVMgPqLYcf49uOw8klQU8_zkoMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexx1JIYZHaeorFSpm2RWRl9hOJNxsTECX01HhH9DA_xQgMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/activites/index.vue?macro=true";
import { default as addkumRb1COuK9LulCrPQ4KF6_45TQMwGzQuAmEWa2o6bXtwMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexBAyOXCj_Xo4UmwnIRzkCAf6p6J5aeOCiyatBrykTYCsMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editm_45d6Ue9BeVe1xQuRG_KQsFlNB0kVXSVSTuWgH7uW9gQMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_936GvoAMPxPzFRCGZw39X08btTvXvG8G9_uzokrBzGkaEMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planeteyKnfhKe18ZHew4So615K8MOm5Yd0ZDAd7z9B5aq_83wMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexU4wsTYqZR_cLmo_45fZy48qFa63LB4iUzqRRs847C0H90Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationsyeYnRHWK_45CjZLoFGVOnhde5VQG_Qy8CSHVTLb4vwZIcMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/participations.vue?macro=true";
import { default as indexLhwVJRtDYT7nUz3lIJxvaYp7PzyNGtI7J6CrzwNjAxUMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsRsPS_rPUTWe1B_tJiKxs2W6_DueXnVSzDnz327Yu1iMMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/referents/activity-logs.vue?macro=true";
import { default as editzPwh0B6IOaFnBdC7ISueuLrvbs_y2CatSKjwpBLraDIMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as index9AE3Livzb1TFU_YcsO51kPAWWSywl4uXhJdw9X0MCTcMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsDMQvO_aMD5G1P8FH54KFmAoKMOhi5U3Xy7u05sVOR2QMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablesoEl8py_458rx1wNlpOkdioTFzrMzFR6BNbnPfMr_45ggNIYMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as edit2mP07EAhtj0ppTCSHHqka4PgUKjH6EjtXhtx4_AQPCcMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexO86t6Mz_T63r5dkFsakCde0QQMohAwQCCuxpkq8E_450gMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as index6HSHWlHrUguXUl3U7GSuk_DqviSQzbLQHFbNj5MSjIkMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45clesSImJjkzWWb3Gt1EiuIfb2SHk4UI3LobRKmQ4ByIUlNUMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editZ1WH0e75yoZ_I_45sNV6ffTdwum_453WUN496yVeRYeKFMgMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profileKVn1Zi8ioiGypkuGaI9Rhds6edrcUpGqD7HMadauqHQMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementVZt8_45mvJZS_450mtfx2rslMSU_45VSENMKIN5RHW4O_hUCMMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsZ6Hl7sLHWzvgj6jMEOJJ7ZdCvpsqTT0s4A814yb2JxYMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editWcDCvu00Tn88YhhDISjt_45vgrHnb9fGypOtSRDfDY7zIMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as addckzQuTcdgzWWEkel68A5hKDc9dqnFToucBTY3fuI_VMMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationw3ki48GHjiPLOwjPaVAlZk_45IF2lVITG0grtpyVfo63sMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexQ1n0Rm9_qkr95NtIeb0jtYijxzwCvT16_GkGiWaaRAQMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as editcqdV3xid_45hHjjv_B06Gdhsto975UnuWVzvPD4Weqzr0Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionszOsfrPw4HPlMgVOdkPMkI8_45Cf7zd03oxZ4ZwSddYaesMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationsAmQKeGMJMI7hiorOPCgHTf6nEgH15SzzqQ_ToVbfMZEMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevolesnpskp0ZEEKY1374gaPpJq1IB8JF2C9qLTt_45fiItm0ZMMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexingFKVdm26rCSa_45mVMLbpupAA9RSVhnXNXH_CicPpUzpLgMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as indexwuroNl8L26mYM_5diwF7M2DM5amezcrk78V_5tDPzH4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as editd_Md78Qhb1gYrj6PulVtAE3XnRhAAxa0q0f14r3hr_EMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexmGAuj_UPFtaU_454rvyvG9z_45AW_45xtcYbYkTuIT7XaJq0oMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profileEOrvqkiI5q_45DRs3e_45S3pe5luqD5cHQImd8R1rUgE5qAMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexMk1NaFxYMjsSwRgQib4DG4nxXp621I7qwxzDHheA6yAMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editCPn2Av4iVnxfX_aQkGXIhBw3yGOSnKz5PDEGXLxwbhsMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addrKOtzqWIr0JiwnYjoh_45YiB1hnNubHjFaGkOkCawJBBUMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencesr5AWYjQI24s_45p4TQMpEALes_45XecmPIq2aXNbGu4NL0EMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferencesCbLepYdB2qq9lWSJYqFP2fyFmj1T9vFpcKBhNYTUjg0Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45usersFJP44nu2cnZzvYI5MJOSeSJjxfFzoLSxEm2WDt194q8Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresIo1R2BEMQZRy4NviilTYtHYvl5PTtnQVyFBo3sx1Sm0Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsablest_45vGdQPtFHzNl59kN2Fh_451myvEOT826b8_45v1S1_45jqfwMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisationB0mu3kTRAe_2YMwTfBy5ycawdTho_4597EPV3ru9l_sI4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedX9G8HIlE2wd_A3c9EIM2s9ICl9eQYIpVEqt5E1uH3HQMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45items0XDeoKqDqQtgZfC4kuJnRH5LQcWxaB1P1x1uhJ2nusoMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45role_45mou_NVzcGfsWxBiunraNnOWQtfGjIQQ_45yDjuKd_xbgMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationsR0_45sx5C1_45qIaTcuXJw0Ld28myGo7K07NHoY7L1sYIGkMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editD8CjAlowTH3Hr8pKKFfxKQly5ZXabkp4iK57RLXLqJ0Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilitesecy5lfK_q0kMz_45XQKtor1bl5guZLbtt2Xh4npM0tkj0Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45linkoM1LR_4PpoNl93bmsH_4551l9S2VC8sO1i7zhgSs6aJ7wMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as index78MLIs1b_KlgMZKR10ddPrVNvdkYh06YUN0qEBN2ot0Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectivite24rQpwCRa_MnZXEro9j5NnKYiOdoWlnVeTbPL23X3G4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisationhmpcONDTj_45evmWMAyEL_45Y_vTwPQCLSrcmxC3y_ZEXwAMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationsKgRbY_45f0p89UWaxQl1k1BsSVA6FfmFhvd0L_459DdQBfoMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantlN3J12jdPY83m6ajC5M4wxTHMq_45zeerzsL2ylksVCHoMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortantHhPt3u2lzqMX_Wv2CX_45xnbEJ_TRJ3uHKEanjRNE28nsMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as indexogtdNwfddWDRyTRDRBRsyf_45WIK4mguPsN24vhh_45ftZ4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeesQM4H_5D7ZZ9THU_hpevTbwTF8Ize4QQwE_45A1YXQIuKsMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validertD6scHULw4FK2vbbSO3_eHIYdf050CTDENIae1LZJ5MMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimees42kqwrkZkb7BFrRfO30f_dzL9E5SFJzN4plMVeqJ9XUMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagesclxNJAuFONF9PaDYJedp7sySz_45ODWaNrdlyaphhJFAAMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45detailsKp8k_45EFrb4PGLG0wHBeCNeNy5qCOu7ONjwuTky_45aOnoMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedL8LmXP4WASlJl90fL9qb2PKgJn3n95qZBx0ZDnYrqcsMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectNK2fcel6KBjztYVgSnEiMSOmmOyb5X3lSaJbmkV0dHEMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45validerxoIjAKpXRF6J48o9RAXvVwmOaHDjoMD3ZXkvKlFO_455wMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnementerj0kYoFuoDgdjinYXVqpoZOmreJEDkxrfG1qFO8_45E4Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationvWOBUtUP81mUR_NjOjmnYny6VasZDOjwNd17mkHwqZ8Meta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationGseEJg3MNVaE4IQBrZzq5XzhzAAdnjVccGIaBgPQt5MMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45validerJr_45LkIvmYYDO5DJ1eAZAwR7vusVeZOPVhB1AxCBuX2oMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annulees7PCpEVtkSKhAlm4imsIjNM1QEJg7X5Weu0nSd0cbymwMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww } from "/build/b374d905-fc78-4032-93e7-3c58233cb01e/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginr5vSxhI_45a6ZvgsPQjkpzB_Wa4DvHjJUtXsSXCAU_MK8Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/login.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgenevbS574GPuTuG1iZUS099d3gvzfkJ4jEctscUHK_8PoMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexvMV6Jvp0GLnlfJ5DvriYQt5OefP106PKhIfVAsNKHUgMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notestG4iCUysvBM_m5sVjznX0oawwGT0XIjuluheYgdkSi0Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexzYWBKLYFXLfgOI3IG4yrHPJFEu0acMkvFaP27w00sn4Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editEhk7Uy0VVr6h3NQe3qHDcb6O36Mbvd1_dX7zk5zE27cMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placesM0LxWIVOVWp11z9RVtAZRm0SIBpmelgcUTkM48zTx70Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_939rplnhWz3jZEMp5vALreaMYcO3oq7c9bD3mMNEZ_45csIMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationskcTUh_45sSNmI8teTuUwmX1ymFMA_1kIzCydMaHCeQ7q8Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexpfW9LKe566NGEV1GAFWQBgYM8pA_451X_45H6W9AmRk0h14Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexxcOy79lfPLXK3tDyi0Q8iKfjp30bT4q5_45STornWh4Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexH8OtL1YimpGbYqXVx_zjvhv57tEo635_45fLNZsr6DwTwMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiquewJXD5RUfmhdrawH1mjexanVLOenhPjUTNq1JvTeF48IMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93p_45bhIQPlxcRNvUtBqE4RFRkl3B3oEVe140oVnqdpQZQMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionsWW2TmFv2x6xH3Sfvc7l4kLJfDiA_45HLseVMoltP22rjYMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexZEhN_HPvz7YDK7_TMC_gdfR3EfOLUSRMghfoi02y1ZIMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisaAjZ_8b2sg9rMUYIm9M_45i5GFpxRZ8t9PVQMqQjQ_45AMsMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logsS4Y75yRVKpc9L5M6Mu6oWoxNayxqzGApgN8EAYhO8lcMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missions0rAnTYYgcAca20s5hb5z1hxDvDaxqKKka_kYmuw4SmoMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsPMElegGXlxCDh_453OdQYctXrho4FTU3aM3dH3i4zF1EEMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/settings.vue")
  },
  {
    name: "quiz-tournee-ete",
    path: "/quiz/tournee-ete",
    meta: tournee_45eteL6DeDn9Y5aEOx43EiOstzhEKbKdLHZfYd43HwYy1NB8Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/quiz/tournee-ete.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: indexYLh75qZcHeKS_2VBD6K_tPVXu1fv_45YIf62xHfQyKuAoMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminuaE8W89B7IT0F298udgcaYpz3K_451XF6a7bh1sB5C65gMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexs7mTzlWSxHtC7Qdtqc_LNYhQ7v9gal10zoP9rBrGVDUMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93lCM_1BQo_45G_452s17YqSxCh9pHm37yGzB9XfeYAw4LPUoMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursmbvMr30yo9M6C2wV4U5lIej2mc15i5Z7LMUMGSzFzrUMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencesExPDQYAmN6odPY02MqX88QTOWZnlP4szgcja_457jRR_45gMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationsIXC_DeVwkKRGa9sgmQymHDM_45AONPSYHcQPV8oOGQG_45AMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93r2JC9xYxv7U1uUKrCYzPR_45C9Yokmk1YLdfYALYx89V4Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsslr7mXqyDinXi_45Z70mmAMAyLXJdeo2iaZuJ5nsM5JTQMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: index6Y5hJhUT04d5JfLuyRk9G0xxack_LMDwGxc6XNIChBwMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addfZ8WtJV4wi_TXMsnngqeLVyoC4fw8vbEt1w95NMWyh8Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_93KTHbn_45mAN7q9Gm3_S_FhCu3uEGaTxQmIafumvFqeCTIMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexy_1BotC7ARA4V883fLNSShuVpNuIqUmux84G93VrSZYMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participationsFLgOwJpWjUN9y0bFU3fwiMENMU53pLeoArTRAB2aEJwMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsMt_45js_45QuVzx4n52qaNy_dKBUL76AtT2lEQu6R7tPvn0Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexnkEkxWlZZlf6SoGzapne5KyEbLUkomt30OXUC442M_45EMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notifications1X6TvGZvwMqYV4g5bHZ7bHlc6VtoTdx0Bj6NDDflFAgMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexrELugclqibTkh1EVnktr_bFen7NrF_45aCzB13Wq5wnOAMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexXVCJ5EJ1CRAAmokoqPQCCyrQqd7BL7DGHERZzxxnWQQMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93v8fkHm_45uBR7z7PJWL_455RXT8QJnLf9Vo6GmKRZXeQRmIMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensemblebzxcsbHXfsDTB6cp95gccDmmhzE8DLg0ErF0IzEwIWUMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationsFbJ18YyP3CbknbR1C2mqrKSoTxv4Mwptv51ZfBfv75YMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagesFdwBGD6DImnLswosVtYN6GoAQTTyCEqx3wqgQDNAASQMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesiTT6UOTCOIFE3mYhbqfX1ZKpp_45_45YVrf0dHIiDgSy7XYMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addYLpYf8QPuwBStl8fdE1pjs8rEYdEyZpXgzJTqcWEaD0Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexXi46sxUe56VJA_4512LS2Rn2dnH_45uqDkNDr3xceig_L5cMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: index1g_45rm26uegf8BXEHXwgpj2gZhr85owTANwG_45VmkMXqUMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: datesFxfdho_ZgLf7leWtUs_45koqSm4nf2RZVpqGJF3X30WpYMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexBxYREYtyZP_45166Pwnjw8vVjhOupOZpVYa3B2MIwRmxEMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieux14vhSvtuK_45Td8eU21Tc8JhaKahw56K4LxnOXG7AntZYMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titleEbET6OoaNR1ZTvGAj3uaEVJguhJfYnjQyxKoRuHuKjQMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: index0XaAfTawOWBds0PALsO9uATbpz91aE0ht6FkNkH8pugMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionsmtE0B3fAbHeNuHuZJkzt3jOWVFpKUwHPEaMfRzjR0e0Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: addmgtyVu0nnVSHF7WYa0ARoIw9EoCOxY_vZuU84Bo4iM4Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuelyJGhqbra4J4V91qFZ9iAfPqglx47t7NTos6K4bOYzTkMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexhIYSsBo0SbK7nSu18OhEo2oHq7DYQBnDynha_45DV2q_IMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexWtwfvRSCDyNRKjXPG5ArRio1EZLA3R54N1jlLzaRQmYMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexVm5WDiVaKv8euyAQlQfoMGTWB6MR0gjHNzbXJjBvI0sMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addV2nuf5F0hhnqM3_aKxEzmfAUZJ_45WwmOR9RQGwgksOo0Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: addW73o7xB_45TVoE4ceNPUSXkmK29XU6ZS6tjRRokgM5xoMMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addraw1lrECAg0JAE7OA4E5k3CZtOuPzpZpVKj4rLeY_45SoMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexm7FdPRGYKUeYKFj50gDw3eIz1rjJuxGYAz5QU2Sv5jMMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversions8OIHj8gx1U_45ya5F6X0f80aOsvYIwsQUXyp6WBplYtDgMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editwt6M_TWf3N24WrZ0m_8xndfYgcnfQp8aZLK14IZYFCoMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: index3fm4C8tAPQkuukcv9_NHkGvgLUd4wkX0n0A1wBKUwwwMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: addozPt1okzkJqC_45UhRHjaxAk5ElgMjanvzEyZu0GRH_45_sMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevolesnYYQb61nZIzFhccKR_mGgDMbj29SXaBnvrViAj9rVi8Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editRE4MRS4PhSxu1ua0U0M4TnWuG_U00J62mMLxXJ6QJAMMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursseaOAZdxRurmf2UpglPgP51KoVxsPyZO4VIwv8TVMMgMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexDkkGKYdA3kgDDslw292GK_45VPsAYu_45lPWkCdmTjbONf8Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: index8Dc5McLX3e6HURPn0cr_45p6z0SnmQp_45iYaZAOcnIw9hIMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendrePo3iry3iiEy6MIrwWnAVMgPqLYcf49uOw8klQU8_zkoMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexx1JIYZHaeorFSpm2RWRl9hOJNxsTECX01HhH9DA_xQgMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: addkumRb1COuK9LulCrPQ4KF6_45TQMwGzQuAmEWa2o6bXtwMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexBAyOXCj_Xo4UmwnIRzkCAf6p6J5aeOCiyatBrykTYCsMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editm_45d6Ue9BeVe1xQuRG_KQsFlNB0kVXSVSTuWgH7uW9gQMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planeteyKnfhKe18ZHew4So615K8MOm5Yd0ZDAd7z9B5aq_83wMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexU4wsTYqZR_cLmo_45fZy48qFa63LB4iUzqRRs847C0H90Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsyeYnRHWK_45CjZLoFGVOnhde5VQG_Qy8CSHVTLb4vwZIcMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsRsPS_rPUTWe1B_tJiKxs2W6_DueXnVSzDnz327Yu1iMMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editzPwh0B6IOaFnBdC7ISueuLrvbs_y2CatSKjwpBLraDIMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: index9AE3Livzb1TFU_YcsO51kPAWWSywl4uXhJdw9X0MCTcMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsDMQvO_aMD5G1P8FH54KFmAoKMOhi5U3Xy7u05sVOR2QMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablesoEl8py_458rx1wNlpOkdioTFzrMzFR6BNbnPfMr_45ggNIYMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: edit2mP07EAhtj0ppTCSHHqka4PgUKjH6EjtXhtx4_AQPCcMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexO86t6Mz_T63r5dkFsakCde0QQMohAwQCCuxpkq8E_450gMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: index6HSHWlHrUguXUl3U7GSuk_DqviSQzbLQHFbNj5MSjIkMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clesSImJjkzWWb3Gt1EiuIfb2SHk4UI3LobRKmQ4ByIUlNUMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editZ1WH0e75yoZ_I_45sNV6ffTdwum_453WUN496yVeRYeKFMgMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profileKVn1Zi8ioiGypkuGaI9Rhds6edrcUpGqD7HMadauqHQMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsZ6Hl7sLHWzvgj6jMEOJJ7ZdCvpsqTT0s4A814yb2JxYMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editWcDCvu00Tn88YhhDISjt_45vgrHnb9fGypOtSRDfDY7zIMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: addckzQuTcdgzWWEkel68A5hKDc9dqnFToucBTY3fuI_VMMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexQ1n0Rm9_qkr95NtIeb0jtYijxzwCvT16_GkGiWaaRAQMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: editcqdV3xid_45hHjjv_B06Gdhsto975UnuWVzvPD4Weqzr0Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionszOsfrPw4HPlMgVOdkPMkI8_45Cf7zd03oxZ4ZwSddYaesMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationsAmQKeGMJMI7hiorOPCgHTf6nEgH15SzzqQ_ToVbfMZEMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexingFKVdm26rCSa_45mVMLbpupAA9RSVhnXNXH_CicPpUzpLgMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: indexwuroNl8L26mYM_5diwF7M2DM5amezcrk78V_5tDPzH4Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: editd_Md78Qhb1gYrj6PulVtAE3XnRhAAxa0q0f14r3hr_EMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexmGAuj_UPFtaU_454rvyvG9z_45AW_45xtcYbYkTuIT7XaJq0oMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profileEOrvqkiI5q_45DRs3e_45S3pe5luqD5cHQImd8R1rUgE5qAMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexMk1NaFxYMjsSwRgQib4DG4nxXp621I7qwxzDHheA6yAMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editCPn2Av4iVnxfX_aQkGXIhBw3yGOSnKz5PDEGXLxwbhsMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addrKOtzqWIr0JiwnYjoh_45YiB1hnNubHjFaGkOkCawJBBUMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesr5AWYjQI24s_45p4TQMpEALes_45XecmPIq2aXNbGu4NL0EMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferencesCbLepYdB2qq9lWSJYqFP2fyFmj1T9vFpcKBhNYTUjg0Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45usersFJP44nu2cnZzvYI5MJOSeSJjxfFzoLSxEm2WDt194q8Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresIo1R2BEMQZRy4NviilTYtHYvl5PTtnQVyFBo3sx1Sm0Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisationB0mu3kTRAe_2YMwTfBy5ycawdTho_4597EPV3ru9l_sI4Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedX9G8HIlE2wd_A3c9EIM2s9ICl9eQYIpVEqt5E1uH3HQMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45items0XDeoKqDqQtgZfC4kuJnRH5LQcWxaB1P1x1uhJ2nusoMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45role_45mou_NVzcGfsWxBiunraNnOWQtfGjIQQ_45yDjuKd_xbgMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationsR0_45sx5C1_45qIaTcuXJw0Ld28myGo7K07NHoY7L1sYIGkMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editD8CjAlowTH3Hr8pKKFfxKQly5ZXabkp4iK57RLXLqJ0Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilitesecy5lfK_q0kMz_45XQKtor1bl5guZLbtt2Xh4npM0tkj0Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkoM1LR_4PpoNl93bmsH_4551l9S2VC8sO1i7zhgSs6aJ7wMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: index78MLIs1b_KlgMZKR10ddPrVNvdkYh06YUN0qEBN2ot0Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectivite24rQpwCRa_MnZXEro9j5NnKYiOdoWlnVeTbPL23X3G4Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationhmpcONDTj_45evmWMAyEL_45Y_vTwPQCLSrcmxC3y_ZEXwAMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationsKgRbY_45f0p89UWaxQl1k1BsSVA6FfmFhvd0L_459DdQBfoMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantlN3J12jdPY83m6ajC5M4wxTHMq_45zeerzsL2ylksVCHoMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortantHhPt3u2lzqMX_Wv2CX_45xnbEJ_TRJ3uHKEanjRNE28nsMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexogtdNwfddWDRyTRDRBRsyf_45WIK4mguPsN24vhh_45ftZ4Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesQM4H_5D7ZZ9THU_hpevTbwTF8Ize4QQwE_45A1YXQIuKsMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validertD6scHULw4FK2vbbSO3_eHIYdf050CTDENIae1LZJ5MMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimees42kqwrkZkb7BFrRfO30f_dzL9E5SFJzN4plMVeqJ9XUMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagesclxNJAuFONF9PaDYJedp7sySz_45ODWaNrdlyaphhJFAAMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsKp8k_45EFrb4PGLG0wHBeCNeNy5qCOu7ONjwuTky_45aOnoMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedL8LmXP4WASlJl90fL9qb2PKgJn3n95qZBx0ZDnYrqcsMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45validerxoIjAKpXRF6J48o9RAXvVwmOaHDjoMD3ZXkvKlFO_455wMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationvWOBUtUP81mUR_NjOjmnYny6VasZDOjwNd17mkHwqZ8Meta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationGseEJg3MNVaE4IQBrZzq5XzhzAAdnjVccGIaBgPQt5MMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validerJr_45LkIvmYYDO5DJ1eAZAwR7vusVeZOPVhB1AxCBuX2oMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annulees7PCpEVtkSKhAlm4imsIjNM1QEJg7X5Weu0nSd0cbymwMeta || {},
    component: () => import("/build/b374d905-fc78-4032-93e7-3c58233cb01e/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/user/settings",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/inscription/organisation",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/statistiques",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  },
  {
    name: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXwwMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubmyTL00fv9gJq45xiSbA_12sGcvVSeF7fO0NOOOCJXww
  }
]